import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    width: 300,
    height:300,
      margin: "auto",
    '& h2':{
        color:'#0a0e51',
        'font-family': 'Nunito',
        'font-size':'22px',
        'margin-bottom':'1px'
    },
    '& p':{
        color:'#0a0e51',
        'font-family': 'Nunito',
        'font-size':'19px',
        'padding-top': '20px',
        width: '100%'
    }


  },
  media: {
    height: "75px",
    width: "80px",
    marginTop:"20px",
    // marginLeft:"20px",
      margin: "auto"
  },


});


export default function ImgMediaCard(props) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.media}
        image={props.benefit.image}
        title= {props.benefit.title}
      />
      <CardContent>

        <h2>
         {props.benefit.title}

        </h2>
        <Typography variant="body2" color="textSecondary" component="p">
             {props.benefit.content}
        </Typography>
      </CardContent>
    </Card>
  );
}
